<template>
  <div class="field">
    <label class="label" v-if="label">{{ label }}</label>
    <p class="control has-icons-left">
      <input class="input" type="number"
            v-model="content"
            :placeholder="placeholder"
            @input="handleInput" />
      <span class="icon is-small is-left">
        <i class="fa fa-euro"></i>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MoneyInput',
  props: {
    label: String,
    value: String,
    placeholder: String
  },
  watch: {
    value (newValue, oldValue) {
      this.content = newValue
    }
  },
  data () {
    return {
      content: this.value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.content)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/MoneyInput.vue